module.exports = "<tf-market-map on-security-selected=\"ctrl.securityChanged(security)\"></tf-market-map>";